// Growthifye Grid podcast mark — a microphone capsule built from grid bars that read as an audio waveform, topped by the
// Growthifye lime "signal" dot. Sharp-edged to match the site's square geometry. Inherits currentColor for the frame.
export const PodcastMark = ({ className = "w-10 h-10", accent = "#C8FF00", title = "Growthifye Grid podcast" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title} data-testid="podcast-mark">
    <title>{title}</title>
    <rect x="2" y="2" width="60" height="60" fill="none" stroke="currentColor" strokeOpacity="0.35" strokeWidth="2" />
    <rect x="22" y="10" width="20" height="30" rx="10" fill="none" stroke="currentColor" strokeWidth="2.5" />
    <g fill={accent}>
      <rect x="26" y="20" width="3" height="10" />
      <rect x="30.5" y="15" width="3" height="20" />
      <rect x="35" y="22" width="3" height="6" />
    </g>
    <path d="M16 30c0 9 7 16 16 16s16-7 16-16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square" />
    <path d="M32 46v9M22 55h20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square" />
    <g stroke="currentColor" strokeOpacity="0.45" strokeWidth="1.5">
      <path d="M8 22h8M8 30h5M8 38h8" />
      <path d="M48 22h8M51 30h5M48 38h8" />
    </g>
    <circle cx="52" cy="12" r="4" fill={accent} />
  </svg>
);
